const SAMPLE_PROJECT_NAME = "my-first-zeet-project";

export const SAMPLE_PROJECT_STATUS = "Sample Project";

export const isSampleProject = (projectName?: string) => {
  return projectName === SAMPLE_PROJECT_NAME;
};
